import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PwaInstallService {
  // Signal om te tracken of de installatie beschikbaar is
  canInstall = signal(false);
  
  private deferredPrompt: BeforeInstallPromptEvent | null = null;

  constructor() {
    this.setupInstallPrompt();
  }

  private setupInstallPrompt() {
    // Luister naar beforeinstallprompt event
    window.addEventListener('beforeinstallprompt', (event: Event) => {
      // Voorkom dat de browser de installatie-prompt automatisch toont
      event.preventDefault();
      
      // Sla de event op voor later gebruik
      this.deferredPrompt = event as BeforeInstallPromptEvent;
      
      // Update signal zodat de knop zichtbaar wordt
      this.canInstall.set(true);
    });

    // Reset wanneer de app succesvol is geïnstalleerd
    window.addEventListener('appinstalled', () => {
      // Verwijder de opgeslagen prompt
      this.deferredPrompt = null;
      this.canInstall.set(false);
    });
  }

  /**
   * Toon de installatieprompt aan de gebruiker
   */
  async promptInstall(): Promise<void> {
    if (!this.deferredPrompt) {
      return;
    }

    try {
      // Toon de installatieprompt
      this.deferredPrompt.prompt();
      
      // Wacht op gebruikersreactie
      const { outcome } = await this.deferredPrompt.userChoice;
      
      if (outcome === 'accepted') {
        console.log('PWA geïnstalleerd door gebruiker');
      } else {
        console.log('PWA-installatie afgewezen door gebruiker');
      }
      
      // Maak de prompt opnieuw bruikbaar door deze null te zetten
      // (hij kan maar één keer gebruikt worden)
      this.deferredPrompt = null;
      this.canInstall.set(false);
    } catch (error) {
      console.error('Fout bij PWA-installatie:', error);
    }
  }
}

// TypeScript interface voor beforeinstallprompt event
interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{
    outcome: 'accepted' | 'dismissed';
  }>;
}
